import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { ManagedCardService } from "./managecards.service";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { CardHistory, CardHistoryModel, CardRequest, CardRequestModel } from "./managecards";
import { ApiEndPoints } from "../api.endpoints";
import { LoaderService } from "../LoaderService";

declare var $: any;

@Component({
  templateUrl: "./managedcards.cardhistory.component.html"
})
export class CardHistoryComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Manage Cards';
  public managedCardsName: string = 'cardhistory';
  public cardHistoryList: CardHistory[];
  public cardHistory: CardHistory;
  public cardRequestList: CardRequest[];
  public cardRequestModel: CardRequestModel;

  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private managedCardService: ManagedCardService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.cardHistoryOnInit();
    this.datefilerInitiate();
    
  }
  ngAfterViewInit(): void {
    $('#modal-drawings').on('hidden.bs.modal', function () {
      $('#drawingsdatatable').DataTable().destroy();
      //$('#drawingsdatatable').empty();
    
    });
  }
  datefilerInitiate() {
    $(document).ready(function () {
      jQuery.extend($.fn.dataTableExt.oSort, {
        "date-uk-pre": function (a) {
          if (a == null || a == "") {
            return 0;
          }
          var ukDatea = a.split('-');          
          return (ukDatea[2].split(' ')[0] + ukDatea[1] + ukDatea[0]) * 1;
        },

        "date-uk-asc": function (a, b) {
          return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },

        "date-uk-desc": function (a, b) {
          return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
      });
    });
  }

  cardHistoryOnInit(): void {    
    this.loaderService.display(true);
    this.loadCardHistoryList();
  }
  afterloaddata() {
    $('#cardhistorydatatable').DataTable({
      //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
      dom: '<"top"fip<"clear">>rt<"bottom"ip<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 30,
      order: [],
      columnDefs: [{ orderable: true, targets: [4] }, { type: 'date-uk', targets: [0] }],
      fixedColumns: true,
    });


    // DataTable
    var table = $('#cardhistorydatatable').DataTable();

    // Apply the search
    table.columns().every(function () {
      var that = this;

      $('input', this.footer()).on('keyup change', function () {
        if (that.search() !== this.value) {
          that
            .search(this.value)
            .draw();
        }
      });
    });
  }

  loadCardHistoryList() {    
    var model: CardHistoryModel = new CardHistoryModel();    
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.CardHistoryEndPoint;
    this.managedCardService.getCardHistories(model)
      .subscribe(
      (list: CardHistory[]) => {
        this.cardHistoryList = list;        
        setTimeout(() => {
          this.afterloaddata();
          this.loaderService.display(false);
        }, 100);
      },
      (error: any) => {
        this.loaderService.display(false);
        this.managedCardService.showError("Card History retrieval problem", <any>error);
      }
    );
  }

  openListOfCards(cardHistory: CardHistory) {
    this.loaderService.display(true);
    this.cardHistory = cardHistory;
    this.resetCardRequestTabel();
    this.readCards(this.cardHistory.id);
  }
  resetCardRequestTabel() {
    this.cardRequestList = [];
  }
  readCards(id: string) {
    this.cardRequestModel = new CardRequestModel();
    this.cardRequestModel.Token = this.authService.getToken().access_token;
    this.cardRequestModel.EndPointURL = ApiEndPoints.CardRequestEndPoint;
    this.cardRequestModel.RequestId = id;
    this.managedCardService.getCardRequests(this.cardRequestModel)
      .subscribe(
      (list: CardRequest[]) => {
        this.cardRequestList = list;
        setTimeout(() => {
          this.afterRequestLoadData();
          this.loaderService.display(false);
        }, 100);
      },
      (error: any) => {
        this.managedCardService.showError("Card Request retrieval problem", <any>error)
        this.loaderService.display(false);
      }
      );    
  }
  afterRequestLoadData() {
    if (!$.fn.DataTable.isDataTable('#drawingsdatatable')) {
      var drawingstable =$('#drawingsdatatable').DataTable({
        //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
        //dom: '<"top"i<"clear">>rt<"bottom"i<"clear">>',
        //dom: '<"top"i<"clear">>rt<"bottom"i<"clear">>',
        dom: '<"top"fip<"clear">>rt<"bottom"ip<"clear">>',
        responsive: true,
        info: false,
        iDisplayLength: 20,
        ordering: false,
        fixedColumns: true,

      });
      this.loaderService.display(false);
      $('#modal-drawings').modal('show');
      drawingstable.responsive.recalc();
    }
    
  }
 
}



// WEBPACK FOOTER //
// ./src/app/managecards/managedcards.cardhistory.component.ts